__webpack_require__.p = "/4d1555c0070adc3f2b4d0f601a2ede54b0b7a932/assets/novosales/js/";